import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNav from './locales/en/nav.json';
import enLanding from './locales/en/landing.json';
import enHome from './locales/en/home.json';
import enBreathworks from './locales/en/breathworks.json';
import enJourneys from './locales/en/journeys.json';
import enPlayer from './locales/en/player.json';
import enPricing from './locales/en/pricing.json';
import enProfile from './locales/en/profile.json';
import enUpgrade from './locales/en/upgrade.json';
import enAchievements from './locales/en/achievements.json';
import enActivity from './locales/en/activity.json';
import enContact from './locales/en/contact.json';
import enWelcome from './locales/en/welcome.json';

export const defaultNS = 'common' as const;

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    nav: enNav,
    landing: enLanding,
    home: enHome,
    breathworks: enBreathworks,
    journeys: enJourneys,
    player: enPlayer,
    pricing: enPricing,
    profile: enProfile,
    upgrade: enUpgrade,
    achievements: enAchievements,
    activity: enActivity,
    contact: enContact,
    welcome: enWelcome,
  },
} as const;

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  ns: Object.keys(resources.en),
  resources,
  interpolation: { escapeValue: false },
  initImmediate: false,
});

export default i18n;
